module.exports = __webpack_public_path__ + "img/retailer-two.c292b1b4.png";